/**
 * Constants for step containers components
 * Layout and animation configuration for steps
 *
 * Note: Step spacing is now viewport-based and calculated dynamically.
 * See step-spacing.utils.ts for spacing breakpoints.
 */

export const STEP_CONTAINERS_CONSTANTS = {
  // Layout
  // @deprecated STEP_WIDTH.MINIMUM is no longer used - spacing is now viewport-based
  STEP_WIDTH: {
    MINIMUM: 150, // px - deprecated, kept for backwards compatibility
  },

  Z_INDEX: 2,

  // Spacing
  LABEL_MARGIN_TOP: 8, // px

  // Z-Index
  NODE_Z_INDEX: 20, // Very high z-index to ensure nodes are always on top of progress lines

  // Animations
  STEP_ENTRANCE: {
    DURATION: '0.6s',
    EASING: 'cubic-bezier(0.4, 0, 0.2, 1)',
    STAGGER_DELAY: 0.1, // seconds per step
    INITIAL: {
      OPACITY: 0,
      SCALE: 0.8,
      TRANSLATE_Y: '10px',
    },
    FINAL: {
      OPACITY: 1,
      SCALE: 1,
      TRANSLATE_Y: '0',
    },
  },
} as const;
